const getDisplayName = (toolType) => {
    return toolType
        .split('_')
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ');
};
export const getRenamedColumns = (columns, newColumn, toolType) => {
    let suffix = 0;
    const toolSuffix = getDisplayName(toolType);
    let root = newColumn;
    if (!columns.find((column) => column === newColumn))
        return newColumn;
    const parts = newColumn.split('_');
    if (parts.length > 1) {
        const last = parts[parts.length - 1];
        if (!isNaN(parseInt(last))) {
            suffix = parseInt(last);
            root = newColumn.slice(0, newColumn.length - last.length - 1);
        }
    }
    while (true) {
        suffix = suffix + 1;
        const newName = `${root}_${toolSuffix}_${suffix}`;
        if (!columns.find((column) => column === newName))
            return newName;
    }
};
export const getRenameColumnsV2 = (leftColumns, rightColumns) => {
    // WP-23613 :
    // Compute a unique set of names, ensuring:
    //  1. columns names are case insensitive
    //
    // 2. Names with a trailing '-####' are incremented to find new names:
    //   e.g. ['a-2'],['a-2'] -> ['a-3'], not ['a-2-2']
    // Rationale: this minimizes suffix length and is easier to understand
    //
    // 3. Only duplicated columns are renamed:
    //   e.g. ['A'],['a','a-2'] -> ['A-3''a-2'], not ['a-2','a-3']
    const uniques = new Set(Array.from([...leftColumns, ...rightColumns]).map((item) => item.toLowerCase()));
    const renames = new Map();
    const leftColumnsCased = leftColumns.map((element) => {
        return element.toLowerCase();
    });
    for (const origName of rightColumns) {
        const changedName = origName.toLowerCase();
        let alias = origName;
        if (leftColumnsCased.includes(changedName) || renames.has(origName)) {
            let suffix = 1;
            let root = origName;
            const parts = origName.split('-');
            if (parts.length > 1) {
                const last = parts[parts.length - 1];
                const numeric = /^[0-9]+$/;
                if (numeric.exec(last) !== null) {
                    suffix = parseInt(last, 10);
                    root = origName.substring(0, origName.length - last.length - 1);
                }
            }
            // eslint-disable-next-line no-constant-condition
            while (true) {
                suffix += 1;
                // Truncate the root to fit the suffix
                // Includes the '-' in the suffix length
                const suffixLength = suffix.toString().length + 1;
                if (root.length + suffixLength > 150) {
                    root = root.substring(0, 150 - suffixLength);
                }
                alias = `${root}-${suffix}`;
                const renamesValuesLower = Array.from(renames.values()).map((item) => item.toLowerCase());
                if (!uniques.has(alias.toLowerCase()) && !renamesValuesLower.includes(alias.toLowerCase())) {
                    break;
                }
            }
        }
        renames.set(origName, alias);
    }
    return renames;
};
export const getAllColumnNames = (source) => {
    return source.map((col) => col.name);
};
//# sourceMappingURL=toolConfigUtil.js.map